module.exports = __webpack_public_path__ + "static/media/logo.e9f34ff7.jpg";